import instance from 'utils/API';

import { hub_events } from 'core/constants/hubEvents';

export const createStripePayment = async ({
	connectionId,
	amountOfDocuments,
}: {
	connectionId: string;
	amountOfDocuments: number;
}) => {
	try {
		const response = await instance.post('/checkOut/createPayment', {
			connectionId,
			SignalMethodName: hub_events.action.successfulPaymentSignalRMethodName,
			AmountOfTickets: amountOfDocuments,
			successUrl: `${window.location.href}payment-success`,
			cancelUrl: `${window.location.href}payment-cancel`,
		});

		return response.data;
	} catch (error: any) {
		console.log(error);
	}
};
